/** Build the access object passed to BookShell / TopNav from Rails data-props. */
export function accessFromProps(props = {}) {
  return {
    access_role: props.access_role,
    access_role_label: props.access_role_label,
    can_create_company: props.can_create_company,
    can_enter_transactions: props.can_enter_transactions,
    can_approve_documents: props.can_approve_documents,
    can_manage_company_settings: props.can_manage_company_settings,
    is_viewer: props.is_viewer,
    needs_company: props.needs_company,
    allowed_modules: props.allowed_modules,
    allowed_sections: props.allowed_sections,
    default_home_path: props.default_home_path,
    membership_role: props.membership_role,
    current_user_id: props.current_user_id,
  }
}
